import React,{useEffect,useState,useCallback} from "react";
import Spinner from "../Spinner/Spinner";
import {connect} from "react-redux";
import * as actions from "../../store/actions/index";
import {withRouter} from "react-router-dom"
import FlexContainer from "../UI/FlexContainer/FlexContainer"
const SpecfifcWorkoutAdmin = props=>{

   useEffect(()=>{
        let {workoutId,workoutTitle} = props.match.params;
        props.onFetchSpecificWorkoutAdmin(workoutTitle,workoutId)
 
   },[])

   const plan = props.specificWorkout;

  let [inputWorkout, setWorkout] = useState({
    // id: props.plan.workouts.id,
    // title: props.plan.workouts.title,
    // url: props.plan.workouts.url,
  });

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setWorkout({ ...inputWorkout, [name]: value });
  }); 

  const handleEditWorkout = (e) => {
    e.preventDefault();
    let editedWorkout = {
      id: inputWorkout.id,
      title: inputWorkout.title,
      url: inputWorkout.url,
    };
    // console.log(editedWorkout, props.plan);
    props.onEditWorkout(editedWorkout, props.specificWorkout);
  };

  const handleDeleteWorkout = (e, id) => {
    e.preventDefault();
    // console.log(id, props.plan.id);
    props.onDeleteWorkout(id, plan.id);
  };
   
    if(props.workoutsLoading){
        return <Spinner/>;
    }
    
    return(
        <>
        {/* className="container" */}
        <div className="container" >
          
           {props.specificWorkout?( 
            
           < > 
               <div className="p-2 pt-3">
                    <h5>{plan.title}</h5>
               </div>
                <FlexContainer>

        {plan.workouts.map((workout) => (
           
              <div style={{minHeight:"240px",maxHeight:"250px"}}>
                <iframe
                  height="80%"
                  width="100%"
                  src={workout.url}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen="allowfullscreen"
                  mozallowfullscreen="mozallowfullscreen"
                  msallowfullscreen="msallowfullscreen"
                  oallowfullscreen="oallowfullscreen"
                  webkitallowfullscreen="webkitallowfullscreen"
                ></iframe>
                <span >
                  <p>
                    <h6>{workout.title} </h6>
                   
                    <button
                      className="btn btn-primary btn-sm m-2"
                      data-toggle="modal"
                      data-target={`#edit${workout.id}${plan.id}`}
                      onClick={() => {
                        setWorkout((inputWorkout = workout));
                      }}
                    >
                      Edit 
                    </button>
                    {/* ------------------------------------ Edit Workout Modal starts ------------------------------------*/}
                    <div
                      className="modal fade"
                      id={`edit${workout.id}${plan.id}`}
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Editing: <b>{workout.title}</b>
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="form-group">
                              <label htmlFor="title" className="col-form-label">
                                Title:
                              </label>
                              <input
                                name="title"
                                type="text"
                                className="form-control"
                                id="title"
                                value={inputWorkout.title}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="title" className="col-form-label">
                                Youtube URL:
                              </label>
                              <textarea
                                name="url"
                                type="text"
                                className="form-control"
                                id="url"
                                value={inputWorkout.url}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={handleEditWorkout}
                              disabled={props.editBtnLoading}
                            >
                              {props.editBtnLoading ? "Saving" : "Save"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ------------------------------------ Edit Workout Modal ends ------------------------------------*/}
                    <button
                      className="btn btn-primary btn-sm m-2"
                      data-toggle="modal"
                      data-target={`#delete${workout.id}${plan.id}`}
                      // onClick={() => {setWorkout(id: )}}
                    >
                      Delete
                    </button>
                    {/* ------------------------------------ Delete Workout Modal starts ------------------------------------*/}
                    <div
                      className="modal fade"
                      id={`delete${workout.id}${plan.id}`}
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Irreversible Operation
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <p>
                              Are you sure you want to delete{" "}
                              <b>{workout.title}</b>
                            </p>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={(e) =>
                                handleDeleteWorkout(e, workout.id)
                              }
                              disabled={props.deleteBtnLoading}
                            >
                              {props.deleteBtnLoading ? "Deleting" : "Delete"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div> 
                    {/* ------------------------------------ Delete Workout Modal ends ------------------------------------*/}
                  </p>
                </span>
              </div>
           
          ))}

                </FlexContainer>
                
            </>
            ):null
            
            }

        </div> 

        </>
    )
}

const mapStateToProps = state=>{
    return{
        workoutsLoading:state.workouts.workoutsLoading,
        specificWorkout:state.workouts.specificWorkout,
        editBtnLoading: state.workouts.editWorkoutLoading,
        deleteBtnLoading: state.workouts.deleteWorkoutLoading,
    }
}

const mapDispatchToProps = dispatch=>{
    return{
        onFetchSpecificWorkoutAdmin:(workoutTitle,id)=>dispatch(actions.fetchSpecificWorkoutAdmin(workoutTitle,id)),
        onEditWorkout: (editedWorkout, actualWorkout) =>
        dispatch(actions.onEditWorkout(editedWorkout, actualWorkout)),
      onDeleteWorkout: (planId, workoutId) =>
        dispatch(actions.onDeleteWorkout(planId, workoutId)),
    }
}
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(SpecfifcWorkoutAdmin));



{/* <div style={{display:"flex",flexWrap:"wrap",}}>
                {
                    plan.workouts.map(workout=>(
                    <div style={{margin:"0.4em",border:"1px solid #dadada",borderRadius: "3px",width:"150px",height:"198px",textAlign:"center"}}>
                            <div > 
                                <iframe height="100%"
                                            width="100%" 
                                            src={workout.url} 
                                            title="YouTube video player" 
                                            frameBorder="0" 
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                            allowFullScreen="allowfullscreen"
                                            mozallowfullscreen="mozallowfullscreen" 
                                            msallowfullscreen="msallowfullscreen" 
                                            oallowfullscreen="oallowfullscreen" 
                                            webkitallowfullscreen="webkitallowfullscreen"
                            ></iframe>
                            <h6 >Youtube Video Title</h6>
                        </div>
                    </div>
                    ))
                }
                    
                </div>  */}